import React from 'react';

const VARIANTS = {
  blue:   { color: '#60a5fa', hoverBg: 'rgba(59,130,246,0.1)' },
  red:    { color: '#f87171', hoverBg: 'rgba(239,68,68,0.1)' },
  indigo: { color: '#818cf8', hoverBg: 'rgba(99,102,241,0.1)' },
};

export default function ActionBtn({ children, variant = 'blue', disabled, className = '', ...props }) {
  const { color, hoverBg } = VARIANTS[variant] || VARIANTS.blue;
  return (
    <button
      {...props}
      disabled={disabled}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all duration-100 disabled:opacity-40 ${className}`}
      style={{ color }}
      onMouseEnter={e => { if (!e.currentTarget.disabled) e.currentTarget.style.backgroundColor = hoverBg; }}
      onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
    >
      {children}
    </button>
  );
}
